import _ from 'underscore';
import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { anime } from 'react-anime';
import cx from 'classnames';

import { Layout, LayoutBlock } from 'components/Layout';

import {
	EntitiesPropType,
	NavigationPropType,
	PromoBlockPropType,
	RubricPropType
} from 'propTypes/common';

import Afisha from './components/Afisha';
import AppPromo from './components/AppPromo';
import Banner from './components/Banner';
import Footer from './components/Footer';
import Information from './components/Information';

import styles from './styles.module.scss';

const PushkinsCardTemplate = ({ menu, rubric, events, topPromoBlock }) => {
	const router = useRouter();
	const appPromoBlockRef = useRef(null);
	const afishaRef = useRef(null);

	useEffect(() => {
		const hashRegexpApp = /#download-app(\?|$)/;
		const hashRegexpAfisha = /#afisha(\?|$)/;

		const scrollToAppPromoBlock = (ref) => {
			if (ref.current) {
				const scrollElement =
					window.document.scrollingElement ||
					window.document.documentElement ||
					window.document.body;

				anime({
					targets: scrollElement,
					scrollTop: ref.current.offsetTop,
					duration: 200,
					easing: 'linear'
				});
			}
		};

		const checkHash = (url) => {
			if (hashRegexpApp.test(url)) {
				scrollToAppPromoBlock(appPromoBlockRef);
			}

			if (hashRegexpAfisha.test(url)) {
				scrollToAppPromoBlock(afishaRef);
			}
		};

		checkHash(router.asPath);

		router.events.on('hashChangeStart', checkHash);
	}, []);

	const links = _([
		{
			title: 'Скачать приложение',
			hash: 'download-app'
		},
		{
			title: 'Смотреть афишу',
			hash: 'afisha'
		}
	]).map((link) => (
		<button
			type="button"
			key={link.hash}
			className={styles.link}
			onClick={() => {
				router.push(
					router.asPath,
					{ hash: link.hash },
					{ shallow: true, scroll: false }
				);
			}}
		>
			{link.title}
		</button>
	));

	const date = new Date();
	const currentYear = date.getFullYear();

	const meta = {
		title: `Пушкинская карта ${currentYear}. Официальный сайт Культура.РФ. Что это, как получить, как оформить?`,
		description:
			'Пушкинская карта для молодежи: что это, как получить, как оформить, Госуслуги. Подробная информация: события, кто может участвовать, программа, учреждения культуры, билеты онлайн. Официальный сайт Культура.РФ'
	};

	return (
		<Layout
			menu={menu}
			meta={meta}
			rubric={rubric}
			topPromoBlock={topPromoBlock}
		>
			<LayoutBlock>
				<Banner appLink={links} />
				<div
					className={cx(styles.linkBlock, styles.hideOnDesktop, styles.medium)}
				>
					{links}
				</div>
			</LayoutBlock>
			<LayoutBlock>
				<Information />
			</LayoutBlock>
			<LayoutBlock ref={appPromoBlockRef}>
				<AppPromo />
			</LayoutBlock>
			{!_.isEmpty(events) && (
				<LayoutBlock ref={afishaRef}>
					<Afisha events={events} linkBlockClassName={styles.linkBlock} />
				</LayoutBlock>
			)}
			<LayoutBlock theme="pushkinsCard">
				<Footer />
			</LayoutBlock>
		</Layout>
	);
};

PushkinsCardTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	rubric: RubricPropType.isRequired,
	events: EntitiesPropType.isRequired,
	topPromoBlock: PromoBlockPropType
};

export default PushkinsCardTemplate;
